import FieldSet, { FieldSetContent } from '@nokia-csf-uxr/ccfk/FieldSet';
import { SingleBandLinkReferenceContext, SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import HelpIcon from '../../HelpIcon';
import Form from 'react-bootstrap/esm/Form';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkReferenceContext, DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Polarization (Copolar, alternate polar, XPIC) & Orientation (vertical or horizontal)
 */
export default class Features extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    /**
     * Remove a feature in the feature list
     * @param arr Array
     * @param value deleted value
     * @returns Array without deleted value
     */
    removeItemOnce(arr: [], value: string|number) {
        return arr.filter(item => ![value].includes(item))
    }

    /**
     * Check if a feature is available for a configuration
     * @param linkUser 
     * @param idFeature 
     * @returns 
     */
    featureAvailable(linkUser: any, idFeature: number) {
        var found = false;
        linkUser[this.getKeyValue("equipConf")].features.forEach((f: { idFeature: number; }) => {
            if(f.idFeature == idFeature) {
                found = true;
                return;
            }  
        });
        return found;
    }

    /**
     * Check if an IdFeature is available in the features of a configuration
     * @param linkUser 
     * @param idFeature 
     * @returns 
     */
    getFeatureConfiguration(linkUser: any, idFeature: number) {
        for (let i = 0; i < linkUser[this.getKeyValue("equipConf")].features.length; i++) {
            if(linkUser[this.getKeyValue("equipConf")].features[i].idFeature == idFeature) {
                return linkUser[this.getKeyValue("equipConf")].features[i];
            }
        }
        return null;
    }
      
    /**
     * Remove or add IdFeature (copolar or alternate polar) in the list of the features
     * @param link link information which has given by the user
     * @param newData The new data which has been selected
     */
    onChangePolar(link: Readonly<any>, newData: any) {
        let features = link[this.getKeyValue("features")] == undefined ? [] : link[this.getKeyValue("features")];

        if(features.includes(newData.target.value)) return features;

        // If polarizaton is 1 then remove 2 in the feature list (2 = alternate polar)
        // If polarization is 2 then remove 1 in the feature list and add 6 (AP)
        if(newData.target.value == 1) {
            features = this.removeItemOnce(features, "2");
            features = this.removeItemOnce(features, "3");
        } else {
            features = this.removeItemOnce(features, "1");
            features = this.removeItemOnce(features, "5");
            if(newData.target.value != "6" && !features.includes("6")) {
                features.push("6"); // With AP, Horizontal is always selected
            }
        }
        features.push(newData.target.value);

        link.define(this.getKeyValue("features"), features);
    }

    /**
     * Add an IdFeature in array list if check or uncheck (for example : XPIC, Adaptative Modulation)
     * @param link 
     * @param newData 
     */
    onChangeCheckBox(link: Readonly<any>, newData: any) {
        let features = link[this.getKeyValue("features")] == undefined ? [] : link[this.getKeyValue("features")];

        if(features.includes(newData.target.value.toString())) {
            features = this.removeItemOnce(features, newData.target.value);
        } else {
            features.push(newData.target.value);
        }
        link.define(this.getKeyValue("features"), features);
    }

     /**
     * Remove or add an IdFeature (horizontal or vertical) in the list of the features
     * @param link link information which has given by the user
     * @param newData The new data which has been selected
     */
     onChangeOrientation(link: Readonly<any>, newData: any) {
        let features = link[this.getKeyValue("features")] == undefined ? [] : link[this.getKeyValue("features")];

        // If orientation is 5 then remove 6 in the feature list (6 = horizontal)
        // If polarization is 6 then remove 5 in the feature list
        if(newData.target.value == 5) {
            features = this.removeItemOnce(features, "6");
        } else {
            features = this.removeItemOnce(features, "5");
        }
        features.push(newData.target.value);

        link.define(this.getKeyValue("features"), features);
    }

    render() {
        return (
        <>
        {this.props.band == 1 ?
        <FieldSet style={{width: "100%"}}>

            <Form.Label className='mt-2'>Polarization <HelpIcon text="CP = Copolar | AP = Alternate Polar" url="" /></Form.Label>

            <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                <SingleBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                    <SingleBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                            <>
                            { st.idFeature == 1 || st.idFeature == 2 ? // If current feature in loop is copolar or alternate polar then display this one
                                <Form.Check
                                    type="radio"
                                    value={st.idFeature}
                                    label={st.shortname}
                                    className="ms-3"
                                    disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                    checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser?.features?.includes(st.idFeature.toString())}
                                    onChange={(e) => this.onChangePolar(linkUser, e) } 
                                />
                            : <></>}

                            {
                                st.idFeature == 3 && !linkUser?.features?.includes("1") ?
                                <>
                                    <Form.Check
                                        type="checkbox"
                                        value={st.idFeature}
                                        label={st.name}
                                        className="ms-3"
                                        disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                        checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser?.features?.includes(st.idFeature.toString())} 
                                        onChange={(e) => this.onChangeCheckBox(linkUser, e)} 
                                    />
                                </>
                            : <></>}
                            </>
                        ) }
                    </>)}
                    </SingleBandLinkUserContext.Consumer>
                    )}
                </SingleBandLinkReferenceContext.Consumer>
            </FieldSetContent>


            <Form.Label>Orientation</Form.Label>

            <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                <SingleBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                    <SingleBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                            <>
                            { st.idFeature == 5 || st.idFeature == 6 ? // If current feature in loop is copolar or alternate polar then display this one
                                <Form.Check
                                    type="radio"
                                    value={st.idFeature}
                                    label={st.name}
                                    className="ms-3"
                                    disabled={!this.featureAvailable(linkUser, st.idFeature) || (st.idFeature == 5 && linkUser?.features?.includes("2"))}
                                    checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser?.features?.includes(st.idFeature.toString())}
                                    onChange={(e) => this.onChangeOrientation(linkUser, e) } 
                                />
                            : <></>}

                            </>
                        ) }
                    </>)}
                    </SingleBandLinkUserContext.Consumer>
                    )}
                </SingleBandLinkReferenceContext.Consumer>
            </FieldSetContent>

            <FieldSetContent role="radiogroup" className="mt-2 mb-2 standard-FieldSetContent">
                <SingleBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                    <SingleBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                            <>
                            { st.idFeature == 7 ?
                                <Form.Check
                                    type="checkbox"
                                    value={st.idFeature}
                                    label={st.name}
                                    disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                    checked={this.featureAvailable(linkUser, st.idFeature) && (this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser?.features?.includes(st.idFeature.toString()))}
                                    onChange={(e) => this.onChangeCheckBox(linkUser, e)}
                                />
                            : <></>}

                            </>
                        ) }
                    </>)}
                    </SingleBandLinkUserContext.Consumer>
                    )}
                </SingleBandLinkReferenceContext.Consumer>
            </FieldSetContent>

        </FieldSet>
        :
        <FieldSet style={{width: "100%"}}>

            <Form.Label className='mt-2'>Polarization <HelpIcon text="CP = Copolar | AP = Alternate Polar" url="" /></Form.Label>

            <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                <DualBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                        <DualBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                            <>
                            { st.idFeature == 1 || st.idFeature == 2 ? // If current feature in loop is copolar or alternate polar then display this one
                                <Form.Check
                                    type="radio"
                                    value={st.idFeature}
                                    label={st.shortname}
                                    className="ms-3"
                                    disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                    checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser[this.getKeyValue("features")]?.includes(st.idFeature.toString())}
                                    onChange={(e) => this.onChangePolar(linkUser, e) } 
                                />
                            : <></>}

                            {
                                st.idFeature == 3 && !linkUser[this.getKeyValue("features")]?.includes("1") ?
                                <>
                                    <Form.Check
                                        type="checkbox"
                                        value={st.idFeature}
                                        label={st.name}
                                        className="ms-3"
                                        disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                        checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser[this.getKeyValue("features")]?.includes(st.idFeature.toString())} 
                                        onChange={(e) => this.onChangeCheckBox(linkUser, e)} 
                                    />
                                </>
                            : <></>}
                            </>
                        ) }
                    </>)}
                    </DualBandLinkUserContext.Consumer>
                    )}
                </DualBandLinkReferenceContext.Consumer>
            </FieldSetContent>


            <Form.Label>Orientation</Form.Label>

            <FieldSetContent role="radiogroup" className="justify-content-center standard-FieldSetContent center-radiobnt">
                <DualBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                    <DualBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                            <>
                            { st.idFeature == 5 || st.idFeature == 6 ? // If current feature in loop is copolar or alternate polar then display this one
                                <Form.Check
                                    type="radio"
                                    value={st.idFeature}
                                    label={st.name}
                                    className="ms-3"
                                    disabled={!this.featureAvailable(linkUser, st.idFeature) || (st.idFeature == 5 && linkUser[this.getKeyValue("features")]?.includes("2"))}
                                    checked={this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser[this.getKeyValue("features")]?.includes(st.idFeature.toString())}
                                    onChange={(e) => this.onChangeOrientation(linkUser, e) } 
                                />
                            : <></>}

                            </>
                        ) }
                    </>)}
                    </DualBandLinkUserContext.Consumer>
                    )}
                </DualBandLinkReferenceContext.Consumer>
            </FieldSetContent>

            <FieldSetContent role="radiogroup" className="mt-2 mb-2 standard-FieldSetContent">
                <DualBandLinkReferenceContext.Consumer>
                    {(linkRef) => (
                    <DualBandLinkUserContext.Consumer>
                    {(linkUser) => (
                        <>
                        { linkUser[this.getKeyValue("equipConf")]?.features == undefined ? <></>
                        : linkRef["features"]?.map((st: {idFeature: number, name: string, shortname: string}, index: any) =>
                        <>
                            { st.idFeature == 7 ?
                                <Form.Check
                                    type="checkbox"
                                    value={st.idFeature}
                                    label={st.name}
                                    disabled={!this.featureAvailable(linkUser, st.idFeature)}
                                    checked={this.featureAvailable(linkUser, st.idFeature) && (this.getFeatureConfiguration(linkUser, st.idFeature)?.mandatory || linkUser[this.getKeyValue("features")]?.includes(st.idFeature.toString()))}
                                    onChange={(e) => this.onChangeCheckBox(linkUser, e)}
                                />
                            : <></>}

                            </>
                        ) }
                    </>)}
                    </DualBandLinkUserContext.Consumer>
                    )}
                </DualBandLinkReferenceContext.Consumer>
            </FieldSetContent>

        </FieldSet>
        }
        </>
        );
    }

}